import React from 'react';
import { Typography, TableCell, TableRow } from '@mui/material';
import { OptimizationOption } from '../../../../types/summarizeTable';
import theme from '../../../../theme/theme';
const OptimizationRow = ({ option }: { option: OptimizationOption }) => {
  return (
    <>
      <TableRow>
        <TableCell colSpan={4} style={{ paddingLeft: 40 }}>
          <Typography variant="body1" sx={{
            color: theme.palette.text.primary,
            fontSize: '16px',
            fontWeight: 500,
          }}>{option.title}</Typography>
        </TableCell>
      </TableRow>
      {option.optCostsResults?.map((result) => (
        <TableRow key={result.id}>
          <TableCell colSpan={3} style={{ paddingLeft: 80 }}>
            <Typography variant="body1" sx={{
              color: theme.palette.text.secondary,
              fontSize: '16px',
              fontWeight: 500,
            }}>{`${result.title}: ${result.contact}`}</Typography>
          </TableCell>
          <TableCell style={{ textAlign: 'right' }}>
            <Typography variant="body1" sx={{
              color: 'rgb(1, 147, 1)',
              fontSize: '16px',
              fontWeight: 600,
            }}>{result.price.toFixed(2)}$</Typography>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};
export default OptimizationRow;
